import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { blue, white } from '@/lib/colours';
import { EventType } from '@/lib/types';

export interface ToggleButtonProps extends ButtonProps {
  selected?: boolean;
  trackClick?: (
    name: string,
    properties: Record<string, any>,
    eventType?: EventType,
  ) => void;
  trackEventName?: string;
  eventType?: EventType;
}

const StyledToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<ToggleButtonProps>(({ theme, selected }) => ({
  padding: '6px 16px',
  borderRadius: 8,
  fontWeight: 'bold',
  backgroundColor: selected ? blue[600] : theme.palette.background.paper,
  color: selected ? white[900] : theme.palette.text.primary,
  border: 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: selected ? blue[800] : theme.palette.action.hover,
    color: selected ? white[900] : theme.palette.text.primary,
  },
}));

export function ToggleButton({
  selected,
  children,
  onClick,
  trackClick,
  trackEventName,
  eventType = EventType.BUTTON_CLICK,
  ...props
}: ToggleButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (trackClick && trackEventName) {
      trackClick(
        trackEventName,
        {
          buttonLabel: children?.toString() || 'Unknown ToggleButton',
        },
        eventType,
      );
    }

    onClick?.(event);
  };

  return (
    <StyledToggleButton selected={selected} onClick={handleClick} {...props}>
      {children}
    </StyledToggleButton>
  );
}
